import { useCallback } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos";
import { Button } from "../Button";
import { Layout } from "../Layouts";
import { RelativeTime, RelativeTimeProps } from "../RelativeTime";

export interface CalendarControllerProps {
  size?: "small" | "medium" | "large";
  onNext?: () => void;
  onPrev?: () => void;
  onReset?: (today: Date) => void;
  unit?: RelativeTimeProps["unit"];
  disabledPrev?: boolean;
  disabledNext?: boolean;
}

export const CalendarController = ({
  onNext,
  onPrev,
  onReset,
  disabledPrev,
  disabledNext,
  unit = "month",
  size = "medium",
}: CalendarControllerProps) => {
  const handleReset = useCallback(() => {
    if (onReset) {
      onReset(new Date());
    }
  }, [onReset]);
  return (
    <div>
      <Layout.Row gap={0.5} nowrap>
        {onPrev && (
          <div>
            <Button
              type="button"
              icon={<ArrowBackIcon />}
              variant="outlined"
              color="primary"
              onClick={onPrev}
              disabled={disabledPrev}
              size={size}
            />
          </div>
        )}
        {onNext && (
          <div>
            <Button
              type="button"
              icon={<ArrowForwardIcon />}
              variant="outlined"
              color="primary"
              onClick={onNext}
              disabled={disabledNext}
              size={size}
            />
          </div>
        )}
        {onReset && (
          <div>
            <Button
              type="button"
              variant="outlined"
              color="primary"
              onClick={handleReset}
              size={size}
            >
              <RelativeTime value={0} unit={unit} numeric="auto" />
            </Button>
          </div>
        )}
      </Layout.Row>
    </div>
  );
};
